const hasUppercase = (value: string) => /[A-Z]/.test(value);
const hasLowercase = (value: string) => /[a-z]/.test(value);
const hasNumber = (value: string) => /[0-9]/.test(value);
const hasSpecialCharacter = (value: string) => /[#?!@$%^&*-]/.test(value);

export { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter };
